import { render, staticRenderFns } from "./familyMembers.vue?vue&type=template&id=2fe35bf6&scoped=true"
import script from "./familyMembers.vue?vue&type=script&lang=js"
export * from "./familyMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe35bf6",
  null
  
)

export default component.exports